import styled from 'styled-components';
import {AlertBox} from '@guestapp/ui';
import {FormFieldWrapper} from 'styled/common';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const InputContainer = styled.div`
  width: 100%;
`;

export const StyledAlertBox = styled(AlertBox)``;

export const StyledFormFieldWrapper = styled(FormFieldWrapper)`
  width: 100%;
`;
